module.exports = __webpack_public_path__ + "img/precs5.9b4af8e2.png";